import React from 'react'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import Text, { TextColor } from 'particles/Text'

interface StringProps {
    value: string
    color?: TextColor
}

interface GridCellProps {
    stringProps: StringProps
}

const GridCell = React.memo(function GridCell(props: GridCellProps) {
    const { stringProps } = props
    return (
        <Text
            scale="bodyS500"
            color={stringProps && stringProps.color ? stringProps.color : stringProps.value ? 'primary' : 'placeholder'}
            style={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                lineHeight: '1em',
            }}
        >
            {stringProps && stringProps.value ? stringProps.value : '-'}
        </Text>
    )
})

export const SimpleStringCell = (params: GridRenderCellParams) => {
    const stringProps: StringProps = params.value as StringProps
    return <GridCell stringProps={stringProps} />
}
